export {
  KEEP,
  removeTypenameFromVariables,
  RemoveTypenameFromVariablesLink,
} from "./removeTypenameFromVariables.js";
